import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { buildAppPath } from '~/b4b/utils/pathHelpers';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { GenerateReportsStep } from './steps/generate-reports-step/GenerateReportsStep';
import { SuccessStep } from './steps/success-step/SuccessStep';

type Props = {
  employerId: string;
};

export const GenerateReportsFlowController: React.FC<Props> = ({ employerId }) => {
  const basePath = buildAppPath('/reports');
  const returnToPath = urlBuilder.reports();

  return (
    <Router>
      <FlowContextProvider basePath={basePath} returnToPath={returnToPath}>
        <Routes>
          <Route
            path={`${basePath}/new`}
            element={
              <StepWrapper name="new">
                {stepProps => <GenerateReportsStep employerId={employerId} {...stepProps} />}
              </StepWrapper>
            }
          />
          <Route
            path={`${basePath}/success`}
            element={<StepWrapper name="success">{stepProps => <SuccessStep {...stepProps} />}</StepWrapper>}
          />
        </Routes>
      </FlowContextProvider>
    </Router>
  );
};
